import { useEffect, useRef, useState } from "react";

const shareTargets = [
  { key: "weibo", label: "微博", icon: "ri-weibo-line" },
  { key: "wechat", label: "微信", icon: "ri-wechat-line" },
  { key: "qq", label: "QQ", icon: "ri-qq-line" },
];

export default function ShareBar({ title }: { title: string }) {
  const [toast, setToast] = useState("");
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  const showToast = (message: string) => {
    setToast(message);
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setToast(""), 2200);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      showToast("链接已复制到剪贴板");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  const handleShare = (label: string) => {
    showToast(`演示功能：已模拟分享到${label}（《${title}》）`);
  };

  return (
    <div className="relative flex flex-wrap items-center gap-2">
      <span className="text-sm text-foreground-500">分享：</span>
      <button
        type="button"
        onClick={handleCopy}
        className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
      >
        <i className="ri-link text-base" />
        复制链接
      </button>
      {shareTargets.map((target) => (
        <button
          key={target.key}
          type="button"
          onClick={() => handleShare(target.label)}
          aria-label={`分享到${target.label}`}
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
        >
          <i className={`${target.icon} text-base`} />
        </button>
      ))}

      {toast && (
        <span className="absolute -top-11 left-0 z-10 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-2 text-xs text-background-50 animate-fade-up">
          {toast}
        </span>
      )}
    </div>
  );
}